import { render, staticRenderFns } from "./email-settings.vue?vue&type=template&id=c865d382&scoped=true"
import script from "./email-settings.vue?vue&type=script&lang=js"
export * from "./email-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c865d382",
  null
  
)

export default component.exports